import { useAuth } from '@/store/auth';
import { QQ_APP_ID, WX_APP_ID, baseFetchTool } from './base';
import { query } from '@/modules/util';

const tokenTypeMap = {
  4: 7,
  1: 4,
  2: 2,
  6: 9,
};

// 暂存扫码支付数据
export const stashQRPayData = (
  option: any,
  successCallback: any,
  errorCallback: any,
) => {
  const { accountInfo } = useAuth.storeInfo();
  const type = accountInfo.logintype === 'qq' ? 4 : 2;
  console.log('++++++++++++++auth_info+++++++++++++', {
    auth_info: {
      nick_name: accountInfo.nickName,
      account: {
        account_type: type,
        account_id: accountInfo.openid,
        appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
      },
      token: {
        token_type: tokenTypeMap[type],
        token: accountInfo.accessToken,
      },
    },
  });
  baseFetchTool(
    'StashQRPayData',
    {
      auth_info: {
        nick_name: accountInfo.nickName,
        account: {
          account_type: type,
          account_id: accountInfo.openid,
          appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
        },
        token: {
          token_type: tokenTypeMap[type],
          token: accountInfo.accessToken,
        },
        ext_info: JSON.stringify({
          ...option,
          appid: query('appid'),
          sceneid: query('scene'),
          fromid: query('fromid'),
        }),
      },
    },
    successCallback,
    errorCallback,
  );
};
